import React, { useEffect, useState } from 'react';
import { useForm } from '../../hooks/useForm';
import { useLocation, NavLink, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { signIn } from "../../controllers/basicAuth";
import { GetUserData } from "../../controllers/GetUserData";
import { FooterMain } from '../footer/FooterMain';
import { Form, TextInput, Button  } from "@wfp/ui";
import {login } from '../../actions/auth';
import { startLoading, finishLoading, setError, setToken } from '../../actions/ui';
import {useDispatch,useSelector} from 'react-redux';
import transEs from '../../translate/es.json';
import transCat from '../../translate/cat.json';
import transDe from '../../translate/de.json';
import transEn from '../../translate/en.json';
import transFr from '../../translate/fr.json';
import transOt from '../../translate/ot.json';
import transPr from '../../translate/pr.json';
import { ConfigApp } from "../../controllers/ConfigApp";
import {encode as base64_encode} from 'base-64';

// Login component
export const LoginScreen = ({ history }) => {
    const [imgBackType, setImgBackType] = useState(false);
    const [imgBack, setImgBack] = useState('');
    const [imgLogoType, setImgLogoType] = useState(false);
    const [imgLogo, setImgLogo] = useState('');
    const [colorThree, setColorThree] = useState('');
    const [colorFour, setColorFour] = useState('');
    const navigate = useNavigate();
    const langTxt = localStorage.getItem('userLanguage') || 'es';
    let transTxt = transEs;
    if(langTxt === 'es'){
        transTxt = transEs;
    }
    else if(langTxt === 'cat'){
        transTxt = transCat;
    }
    else if(langTxt === 'de'){
        transTxt = transDe;
    }
    else if(langTxt === 'en'){
        transTxt = transEn;
    }
    else if(langTxt === 'fr'){
        transTxt = transFr;
    }
    else if(langTxt === 'pr'){
        transTxt = transPr;
    }
    else{
        transTxt = transOt;
    }
    const dispatch = useDispatch();
    const { loading } = useSelector( state => state.ui );
    const location = useLocation();
    const { q = '' } = queryString.parse( location.search );
    const [ formValues, handleInputChange ] = useForm({
        userName: q
    });
    const { userName } = formValues;

    let ran = false;
    useEffect(() => {
        if (ran) return;
            document.getElementById('userName-error-msg').style.display="none";
            document.getElementById('userPassword-error-msg').style.display="none";

            if(!window.localStorage.getItem('edufami_background')){
                ConfigApp("/appConfig").then((e)=>{
                    e.forEach(a => {
                        // eslint-disable-next-line default-case
                        switch (a.name_key) {
                            case "edufami_background" :
                                window.localStorage.setItem('edufami_background', JSON.stringify(a));
                                setImgBackType(a.image_type)
                                setImgBack(a.image_value)
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_logo" :
                                window.localStorage.setItem('edufami_logo', JSON.stringify(a));
                                setImgLogoType(a.image_type)
                                setImgLogo(a.image_value)
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_icon" :
                                window.localStorage.setItem('edufami_icon', JSON.stringify(a));
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_color1" :
                                window.localStorage.setItem('edufami_color1', JSON.stringify(a));
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_color2" :
                                window.localStorage.setItem('edufami_color2', JSON.stringify(a));
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_color3" :
                                window.localStorage.setItem('edufami_color3', JSON.stringify(a));
                                setColorThree(a.text_value)
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_color4" :
                                window.localStorage.setItem('edufami_color4', JSON.stringify(a));
                                setColorFour(a.text_value)
                            break;
                            case "edufami_sponsor1" :
                                window.localStorage.setItem('edufami_sponsor1', JSON.stringify(a));
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_sponsor2" :
                                window.localStorage.setItem('edufami_sponsor2', JSON.stringify(a));
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_sponsor3" :
                                window.localStorage.setItem('edufami_sponsor3', JSON.stringify(a));
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_sponsor4" :
                                window.localStorage.setItem('edufami_sponsor4', JSON.stringify(a));
                            break;
                            case "edufami_feedback_correct" :
                                window.localStorage.setItem('edufami_feedback_correct', JSON.stringify(a));
                            break;
                            case "edufami_feedback_incorrect" :
                                window.localStorage.setItem('edufami_feedback_incorrect', JSON.stringify(a));
                            break;
                            case "edufami_background_courses" :
                                window.localStorage.setItem('edufami_background_courses', JSON.stringify(a));
                            break;
                        }
                    })
                })
                .catch((e)=>{
                    console.warn(e);
                    document.getElementById('invalidMessage').classList.remove('hide');
                    
                });
            }
            else{
                setImgBackType(JSON.parse(window.localStorage.getItem('edufami_background')).image_type)
                setImgBack(JSON.parse(window.localStorage.getItem('edufami_background')).image_value)

                setImgLogoType(JSON.parse(window.localStorage.getItem('edufami_logo')).image_type)
                setImgLogo(JSON.parse(window.localStorage.getItem('edufami_logo')).image_value)

                setColorThree(JSON.parse(window.localStorage.getItem('edufami_color3')).text_value)

                setColorFour(JSON.parse(window.localStorage.getItem('edufami_color4')).text_value)
            }
        return () => (ran = true);
    }, [])
    const handleSubmit = async (e) => {
        e.preventDefault();
        const btnIngreso = document.getElementById("btnIngresar");
        btnIngreso.classList.remove("btn-wfp-main");
        btnIngreso.classList.add("btn-wfp-main-press");
        
        const lastPath = localStorage.getItem('lastPath') || '/home';
        let userPassword = document.getElementById('userPassword').value;
        let userNameErr = document.getElementById('userName');
        if(userName===""){ 
            userNameErr.classList.add("is-invalid");
            document.getElementById('userName-error-msg').classList.add("wfp--form-requirement-show");
            document.getElementById('userName-error-msg').style.display="block";
        }
        else{
            userNameErr.classList.remove("is-invalid");
            document.getElementById('userName-error-msg').classList.remove("wfp--form-requirement-show");
        }
        let userPasswordErr = document.getElementById('userPassword');
        if(userPassword===""){
            userPasswordErr.classList.add("is-invalid");
            document.getElementById('userPassword-error-msg').classList.add("wfp--form-requirement-show");
            document.getElementById('userPassword-error-msg').style.display="block";
        }
        else{
            userPasswordErr.classList.remove("is-invalid");
            document.getElementById('userPassword-error-msg').classList.remove("wfp--form-requirement-show");
            
        }
        if(userName!=="" && userPassword!==""){
            dispatch( startLoading() );
            let dataLog = signIn(userName,userPassword);
            let token
            dataLog.then((e)=>{
                token = e.token
                GetUserData(token)
                .then((e)=>{
                    let lang = 'es';
                    let langId = parseInt(e.language_id)
                    if(langId===1){
                        lang = 'es';
                    }
                    else if(langId===2){
                        lang = 'en';
                    }
                    else if(langId===3){
                        lang = 'pr';
                    }
                    else if(langId===4){
                        lang = 'fr';
                    }
                    else if(langId===5){
                        lang = 'cat';
                    }
                    else if(langId===6){
                        lang = 'de';
                    }
                    else{
                        lang = 'ot';
                    }
                    localStorage.setItem('userLanguage',lang)
                    dispatch(login(e.id,userName,e.language_id))
                    dispatch(setToken(token));
                    dispatch( finishLoading() );
                    const date = new Date();
                    window.localStorage.setItem('login_token', date);
                    navigate( lastPath, {
                        replace: true
                      });
                })
                .catch((e)=>{
                    console.warn(e);
                    document.getElementById('invalidMessage').classList.remove('hide');
                    dispatch( finishLoading() );
                    dispatch( setError(e) );
                });
                    
            })
            .catch((e)=>{
                console.warn(e);
                document.getElementById('invalidMessage').classList.remove('hide');
                dispatch( finishLoading() );
                dispatch( setError(e) );
            });

            
        }
    }

    const hadlePress = (e) => {
        e.currentTarget.classList.remove("btn-wfp-main");
        e.currentTarget.classList.add("btn-wfp-main-press");
    };
    
    return (
        <div className="fund-start">
            {
                imgBackType && (imgBackType==="svg")
                ?
                <img className="fund-start-b-img" src = {`data:image/svg+xml;base64,${base64_encode(imgBack)}`} alt="Back Ground"/>
                :
                <img className="fund-start-b-img" src = {imgBack} alt="Back Ground"/>
            }
            <div className="fund-login-bl-img">
            {
                imgLogoType && (imgLogoType==="svg")
                ?
                <img className="fund-start-l-img" src = {`data:image/svg+xml;base64,${base64_encode(imgLogo)}`} alt="Back Ground"/>
                :
                <img className="fund-start-l-img" src = {`data:image/${imgLogoType}+xml;base64,${btoa(imgLogo)}`} alt="Back Ground"/>
            }
            </div>
            <div className="text-login-main">
                <Form onSubmit={ handleSubmit } className="needs-validation">
                    <strong id="invalidMessage" className="invalid-feedback hide">
                    {transTxt.login.top.txt}
                    </strong>
                    

                    <TextInput
                        placeholder={transTxt.login.placeholder.imp_1}
                        className="form-control txt-input"
                        name="userName"
                        id="userName"
                        autoComplete="off"
                        value={ userName }
                        onChange={ handleInputChange }
                        invalid={{
                            message: ''
                            }}
                        invalidText={transTxt.login.inv_msg.imp_1}
                        required
                    />
                        
                    <TextInput
                        type="password"
                        placeholder={transTxt.login.placeholder.imp_2}
                        className="form-control mb-3 txt-input"
                        id="userPassword"
                        name="userPassword"
                        autoComplete="off"
                        invalid={{
                            message: ''
                            }}
                        invalidText={transTxt.login.inv_msg.imp_2}
                        required
                    />
                    <br/>
                    <Button
                        id="btnIngresar"
                        type="submit"
                        className="btn m-1 btn-block btn-wfp-main"
                        disabled={ loading }
                        style={{
                            backgroundColor: colorThree,
                            borderColor: colorThree,
                        }}
                    >
                        {transTxt.btn.ing.txt}
                    </Button>
                    <br/>
                    <br/>
                    {transTxt.login.bottom.txt_1}
                    <br/>
                    {transTxt.login.bottom.txt_2}
                    <br/>
                    <br/>
                    <NavLink to={ `/auth/registry` }
                        className="btn m-1 btn-block btn-wfp-main wfp--link"
                        onClick={hadlePress}
                    >
                        <Button
                            id="btnRegistrarse"
                            className="btn m-1 btn-block btn-wfp-main"
                            disabled={ loading }
                            style={{
                                backgroundColor: colorFour,
                                borderColor: colorFour,
                                color: "rgb(0, 0, 0, 0.45)"
                            }}
                        >
                            {transTxt.btn.reg.txt}
                        </Button>
                        
                    </NavLink>
                    
                </Form>
            </div>

            <FooterMain />

        </div>
    )
}
